import Enum from '../interfaces/IEnum';

export const FormMode: Enum = {
    enum: {
        CREATING: 0,
        EDITING: 1
    }
};
